import { Reveal, SectionHead } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  ["How much does a website cost?", "Our website packages start from ₹14,999, with final pricing depending on requirements and scope."],
  ["Can you build a website in 24 hours?", "Eligible standard website projects can be launched in as little as 24 hours when required content, branding assets and approvals are provided on time."],
  ["Do you build websites for small businesses?", "Yes. We specifically offer affordable professional website solutions for small and growing businesses."],
  ["Do you build e-commerce websites?", "Yes. E-commerce projects can be developed based on product count, payment requirements, integrations and functionality."],
  ["Is the website mobile responsive?", "Yes. Websites are designed to work across mobile, tablet and desktop devices."],
  ["Do you integrate WhatsApp?", "Yes. WhatsApp enquiry and contact buttons can be integrated."],
  ["Do you provide hosting?", "Yes, hosting and domain support is available as an optional service. Pricing depends on the selected provider and plan."],
  ["Can you redesign an existing website?", "Yes."],
  ["Can I request custom features?", "Yes. Custom functionality can be quoted separately."],
  ["Do standard packages include an admin panel?", "No. Admin panels and custom dashboards are not included in the standard packages. They can be developed as optional custom functionality when required."],
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-ink py-24 md:py-32">
    <div className="mx-auto max-w-3xl px-6 md:px-12">
      <SectionHead center eyebrow="FAQ" title="Questions, answered." />
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-14 space-y-3">
          {FAQS.map(([q, a], i) => (
            <AccordionItem
              key={q}
              value={`item-${i}`}
              className="rounded-xl border border-white/10 bg-charcoal px-6 transition-colors duration-300 data-[state=open]:border-accent/30"
            >
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-5 text-left font-display text-sm font-bold uppercase tracking-wide text-white hover:text-accent hover:no-underline md:text-base">
                {q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-zinc-400">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
